
    import { Component, Vue } from 'vue-property-decorator';
    import { mapActions, mapMutations, mapState } from 'vuex';
    import BriefartenDetail from '@/components/Briefarten/BriefartenDetail.vue';
    import Briefart from '@/types/Briefart';
    import { BriefartenFilter, LoadBriefartenPayload } from '@/store/briefarten';
    import { DataTableHeaders } from '@/types';

    @Component({
        components: {
            BriefartenDetail,
        },
        computed: {
            ...mapState('briefarten', ['briefarten', 'dialogs', 'loaders']),
        },
        methods: {
            ...mapActions('briefarten', ['loadBriefarten']),
            ...mapMutations('briefarten', ['setDialogs']),
        },
    })
    export default class Briefarten extends Vue {
        public loadBriefarten!: (payload?: LoadBriefartenPayload) => void;
        public setDialogs!: (dialogs: { edit?: boolean }) => void;

        public briefart = new Briefart();
        public search = '';

        public filter: BriefartenFilter = {
            gueltig: 'j',
        };

        public get headers(): DataTableHeaders<Briefart> {
            return [
                { text: '', value: 'actions', sortable: false, width: 50 },
                { text: 'Briefart', value: 'briefart' },
                { text: 'Gültig', value: 'gueltig' },
            ];
        }

        public mounted(): void {
            this.loadBriefarten({ filter: this.filter });
        }

        public onChangeFilter(): void {
            this.loadBriefarten({ filter: this.filter });
        }

        public onClickEdit(briefart: Briefart): void {
            this.briefart = new Briefart(briefart);
            this.setDialogs({ edit: true });
        }

        public onClickNew(): void {
            this.briefart = new Briefart();

            this.setDialogs({ edit: true });
        }
    }
